import React, { useState, useEffect } from "react"

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Slide,
    Divider, 
    Tooltip, 
    Box,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography
} from "@mui/material"

import api from "../../../api"
import { getSession } from "../../../auth"

import LoadingButton from "@mui/lab/LoadingButton"

import PropTypes from "prop-types"

import CloseIcon from "@mui/icons-material/Close"

import "./styles.css"

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const MergeEnterpriseDialog = ({ open, enterprises, selectedEnterprises, customFields, handleClose, handleSubmit }) => {

    const [enterprise1, setEnterprise1] = useState({})
    const [enterprise2, setEnterprise2] = useState({})
    const [finalEnterprise, setFinalEnterprise] = useState({})
    const [selectedGroups, setSelectedGroups] = useState([])
    const [enterprise1CustomFields, setEnterprise1CustomFields] = useState({})
    const [enterprise2CustomFields, setEnterprise2CustomFields] = useState({})
    const [finalCustomFields, setFinalCustomFields] = useState({})

    const renderKeys = {
        "name"           : "Nome",
        "social_reason"  : "Razão Social",
        "cnpj"           : "CNPJ",
        "telephone"      : "Telefone",
        "email"          : "E-mail",
        "address"        : "Endereço",
        "address_number" : "Número",
        "address_extra"  : "Complemento",
        "neighborhood"   : "Bairro",
        "city"           : "Cidade",
        "estate"         : "Estado",
        "postal_code"    : "CEP"
    }

    useEffect(() => {
        const enterprise1 = enterprises.find((enterprise) => enterprise.id === selectedEnterprises[0])
        const enterprise2 = enterprises.find((enterprise) => enterprise.id === selectedEnterprises[1])
        setEnterprise1(enterprise1)
        setEnterprise2(enterprise2)
        setFinalEnterprise(enterprise1)
        
        const mergedGroups = []
        const groupIds = new Set()
        
        if (enterprise1.groups && Array.isArray(enterprise1.groups)) {
            enterprise1.groups.forEach(group => {
                if (!groupIds.has(group.id)) {
                    mergedGroups.push(group)
                    groupIds.add(group.id)
                }
            })
        }
        
        if (enterprise2.groups && Array.isArray(enterprise2.groups)) {
            enterprise2.groups.forEach(group => {
                if (!groupIds.has(group.id)) {
                    mergedGroups.push(group)
                    groupIds.add(group.id)
                }
            })
        }
        
        setSelectedGroups(mergedGroups)
        
        const loadCustomFieldValues = async () => {
            const response1 = await api.get(`api/enterprises/${getSession().profile.enterprise.id}/contact_enterprises/${enterprise1.id}/custom_fields/`)
            const response2 = await api.get(`api/enterprises/${getSession().profile.enterprise.id}/contact_enterprises/${enterprise2.id}/custom_fields/`)
            
            const customFieldsData1 = {}
            const customFieldsData2 = {}
            
            if (response1.status === 200) {
                response1.data.forEach(field => {
                    customFieldsData1[field.custom_field] = field.value
                })
            }
            
            if (response2.status === 200) {
                response2.data.forEach(field => {
                    customFieldsData2[field.custom_field] = field.value
                })
            }
            
            setEnterprise1CustomFields(customFieldsData1)
            setEnterprise2CustomFields(customFieldsData2)
            setFinalCustomFields(customFieldsData1)
        }
        
        if (enterprise1 && enterprise2) {
            loadCustomFieldValues()
        }
    }, [])

    const checkSelected = (key, value, priority) => {
        if (value === finalEnterprise[key] && enterprise1[key] === enterprise2[key])
            return priority
        return value === finalEnterprise[key]
    }

    const emptyBox = () => {
        return (
            <Box style={{ height: "20px" }}></Box>
        )
    }

    const updateFinalEnterprise = (key, value) => {
        setFinalEnterprise(prev => ({ ...prev, [key]: value }))
    }

    useEffect(() => {}, [finalEnterprise, selectedGroups])

    return (
        <div>
            <Dialog
                open={open}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                disableEnforceFocus
            >
                <DialogTitle id="alert-dialog-slide-title" className={"group-flexbox"}>
                    <span>Mesclar empresas</span>
                    <Tooltip title="Fechar" >
                        <Button className="action-button">
                            <CloseIcon onClick={handleClose} />
                        </Button>
                    </Tooltip>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    A seguir, selecione o valor que deve ser priorizado no resultado final:
                    <Box className="merge-content">
                        <List>
                            {Object.keys(enterprise1).map((key) => (
                                (key in renderKeys)
                                    ? <ListItem disablePadding key={`${key}-1`} className={checkSelected(key, enterprise1[key], true) ? "item-selected" : ""}>
                                        <ListItemButton onClick={() => updateFinalEnterprise(key, enterprise1[key])}>
                                            <ListItemText 
                                                primary={renderKeys[key]} 
                                                secondary={Array.isArray(enterprise1[key]) ? (enterprise1[key][0] || emptyBox()) : (enterprise1[key] || emptyBox())}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                    : null
                            ))}
                        </List>
                        <List>
                            {Object.keys(enterprise2).map((key) => (
                                (key in renderKeys)
                                    ? <ListItem disablePadding key={`${key}-2`} className={checkSelected(key, enterprise2[key], false) ? "item-selected" : ""}>
                                        <ListItemButton onClick={() => updateFinalEnterprise(key, enterprise2[key])}>
                                            <ListItemText 
                                                primary={renderKeys[key]} 
                                                secondary={Array.isArray(enterprise2[key]) ? (enterprise2[key][0] || emptyBox()) : (enterprise2[key] || emptyBox())}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                    : null
                            ))}
                        </List>
                    </Box>
                    
                    {customFields && customFields.length > 0 && (
                        <>
                            <Typography marginTop="2rem" marginBottom="1rem" fontSize="17px" fontWeight="500" color="#21446c">
                                Campos Customizados
                            </Typography>
                            <Box className="merge-content">
                                <List>
                                    {customFields.map((field) => {
                                        const value1 = enterprise1CustomFields[field.id] || ''
                                        const isSelected1 = finalCustomFields[field.id] === value1 || (!finalCustomFields[field.id] && !value1)
                                        return (
                                            <ListItem disablePadding key={`cf-${field.id}-1`} className={isSelected1 ? "item-selected" : ""}>
                                                <ListItemButton onClick={() => setFinalCustomFields(prev => ({ ...prev, [field.id]: value1 }))}>
                                                    <ListItemText 
                                                        primary={field.field_name}
                                                        secondary={value1 || emptyBox()}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                        )
                                    })}
                                </List>
                                <List>
                                    {customFields.map((field) => {
                                        const value2 = enterprise2CustomFields[field.id] || ''
                                        const isSelected2 = finalCustomFields[field.id] === value2 || (!finalCustomFields[field.id] && !value2)
                                        return (
                                            <ListItem disablePadding key={`cf-${field.id}-2`} className={isSelected2 ? "item-selected" : ""}>
                                                <ListItemButton onClick={() => setFinalCustomFields(prev => ({ ...prev, [field.id]: value2 }))}>
                                                    <ListItemText 
                                                        primary={field.field_name}
                                                        secondary={value2 || emptyBox()}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                        )
                                    })}
                                </List>
                            </Box>
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancelar
                    </Button>
                    <LoadingButton onClick={() => handleSubmit(enterprise1, enterprise2, { ...finalEnterprise, groups: selectedGroups }, finalCustomFields)} color="primary">
                        Enviar
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </div>
    );
}

MergeEnterpriseDialog.propTypes = {
    open: PropTypes.bool,
    selectedEnterprises: PropTypes.array,
    customFields: PropTypes.array,
    handleClose: PropTypes.func,
    handleSubmit: PropTypes.func
};

export default MergeEnterpriseDialog;
